import React, { Fragment } from "react";
import { useFormikContext } from "formik";
import Select from "@components/Formik/Select";
import styles from "./Tabs.module.scss";
import { useLocomotiveContext } from "@providers/LocomotiveProvider";
import _ from "lodash";
import cx from "classnames";
import { Field } from "formik";
import { useTranslationContext } from "@providers/TranslationProvider";

const View = ({
  name,
  validate,
  fast,
  items,
  onChange,
  className,
  border = "",
  theme = "dark",
  mobileHide = false,
  placeholderNoneAmin = false,
  selectStyle = {},
}: any) => {
  const form: any = useFormikContext();
  const { i18n } = useTranslationContext();
  const handler = {
    onChangeTab: (item: any) => {
      const value = _.has(item, "key") ? item.key : item;
      form && form.setFieldValue(name, "");
      _.debounce(() => {
        form && form.setFieldValue(name, value);
      }, 100)();
      onChange && onChange(value);
    },
  };
  const { scroll } = useLocomotiveContext();
  const formValue = form.values[name];
  React.useEffect(() => {
    if (scroll) scroll.update();
  }, [formValue, scroll]);
  React.useEffect(() => {
    _.debounce(() => {
      if (scroll) scroll.update();
    }, 200)();
  }, [scroll]);
  return (
    <section className={cx(styles.section, className, styles[theme])}>
      <div
        className={cx(styles.boxLabel, {
          [styles.borderNone]: border === "none",
        })}
      >
        <Field name={name} validate={validate} fast={fast}>
          {({ field: { value } }: any) => {
            return _.map(items, (item: any, index: number) => (
              <Fragment key={`tab_${index}`}>
                <div
                  className={cx("ama-label", styles.label, {
                    [styles.active]: item.value === value,
                  })}
                  onClick={() => handler.onChangeTab(item)}
                >
                  {item.label}
                </div>
                {index !== items.length - 1 && (
                  <div className={styles.border}>|</div>
                )}
              </Fragment>
            ));
          }}
        </Field>
      </div>
      <div
        className={cx(styles.boxSelect, selectStyle.boxSelect, {
          [styles.hide]: mobileHide,
        })}
      >
        <Select
          type="border"
          placeholder={i18n.t("Form.placeholderAll")}
          className={styles.select}
          placeholderProps={{ className: styles.placeholder }}
          boxOptionProps={{ className: styles.boxOption }}
          optionProps={{ className: styles.option }}
          theme={theme}
          name={name}
          options={items}
          placeholderNoneAmin={placeholderNoneAmin}
          onChange={handler.onChangeTab}
        />
      </div>
      {_.map(items, (item: any, index: number) => (
        <div
          className={cx(styles.boxContent, {
            [styles.active]: item.value === form.values[name],
          })}
          key={index}
        >
          {item.children}
        </div>
      ))}
    </section>
  );
};
export default View;
